exports.onClientEntry = () => {
    window.addEventListener('load', () => {
        document.body.classList.remove('no-js');
    });
};
